const TRANSACTION_TYPES = [
  { id: '0', text: 'Monthly' },
  { id: '1', text: 'Credit' },
  { id: '2', text: 'Failed' },
  { id: '3', text: 'Balance Paid' },
  { id: '4', text: 'Used Credits' },
  { id: '5', text: 'Debug' },
  { id: '6', text: 'Pro-rated' },
  { id: '7', text: 'Annual' },
  { id: '8', text: 'One-time' },
  { id: '9', text: 'One-time iTunes' },
  { id: '10', text: 'Used Upgrade Credits' },
  { id: '11', text: 'Unknown' },
  { id: '12', text: 'Refund' },
  { id: '13', text: 'Units Change' },
  { id: '14', text: 'Plan Change' },
];
const BILLING_ENGINE_FIVE_TZ = 'America/Regina';
export default { TRANSACTION_TYPES, BILLING_ENGINE_FIVE_TZ };
